import React from 'react'
import axios from 'axios';

const ContactSection = class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form:{
        name: '',
        email: '',
        message: ''
      },
      successfulSent: false,
      failureSent:false
    }
  }

  handleSubmit(e){
    e.preventDefault();
    console.log(88,this.state)
    if(!this.validation(this.state.form)){
      return;
    }
    axios({
      method: "POST",
      url:"https://formsubmit.co/ajax/salmeh.samer@gmail.com",
      data:  this.state.form
    }).then((response)=>{
      this.resetForm()
      this.setState({successfulSent: true})
      if (response.data.status === 'success') {
        axios({
          method: "POST",
          url:"https://sheet.best/api/sheets/e29863d6-674b-4784-8de8-68e86981d43a",
          data:  this.state.form
        }).then((response)=>{
          // if (response.data.status === 'success') {
          // }
        })
      } else if (response.data.status === 'fail') {
        this.setState({failureSent: true})
      }
    })
  }

  resetForm(){
    this.setState({
      form:{
        name: '',
        email: '',
        message: ''
      },
      successfulSent: false,
      failureSent: false
    })
  }
  onNameChange(event) {
    this.setState({
      form: {
        ...this.state.form,
        name: event.target.value
      },
      successfulSent: false,
      failureSent: false
    });
  }

  onEmailChange(event) {
    this.setState({
      form: {
        ...this.state.form,
        email: event.target.value
      },
      successfulSent: false,
      failureSent: false
    });
  }

  onMessageChange(event) {
    this.setState({
      form: {
        ...this.state.form,
        message: event.target.value
      },
      successfulSent: false,
      failureSent: false
    });
  }

  validation(form){
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return form.name.match(/^ *$/) === null && form.message.match(/^ *$/) === null && regex.test(form.email)
  }
  render() {
    return (
      <section className="elementor-section contact-section">
          <div className="elementor-container">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="art-section-title">
                    <div className="art-title-frame">
                      <h4 className="art-title-h"> <span> Get in touch </span></h4>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="art-a art-card">
                      <div role="form" className="wpcf7" id="wpcf7-f80-p177-o1" lang="en-US" dir="ltr">
                        <div className="screen-reader-response">
                          <p role="status" aria-live="polite" aria-atomic="true"></p>
                        </div>
                        <form id="contact-form" onSubmit={this.handleSubmit.bind(this)} method="POST">
                          <div className="art-contact-form">
                            <div className="form-group"> 
                              <span className="wpcf7-form-control-wrap your-name">
                                <input type="text" className="form-control" placeholder="Name" id="name" value={this.state.form.name} onChange={this.onNameChange.bind(this)}/>
                              </span> 
                              <label><i className="fas fa-user"></i></label>
                            </div>
                            <div className="form-group"> 
                              <span className="wpcf7-form-control-wrap your-email">
                                <input type="email" className="form-control" placeholder="Email" id="email" aria-describedby="emailHelp" value={this.state.form.email} onChange={this.onEmailChange.bind(this)} />
                              </span> 
                              <label><i className="fas fa-at"></i></label>
                            </div>
                            <div className="form-group"> 
                              <span className="wpcf7-form-control-wrap your-message">
                                <textarea className="form-control" placeholder="Message" rows="5" id="message" value={this.state.form.message} onChange={this.onMessageChange.bind(this)} />
                              </span> 
                              <label><i className="far fa-envelope"></i></label>
                            </div>
                            <div className="art-submit-frame"> 
                              <button className="art-btn art-btn-md art-submit" type="submit"><span>Send message</span></button>
                            </div>
                          </div>
                          {
                            this.state.successfulSent? 
                            <div className="response-output"><i className="far fa-check-circle"></i> Thank you for your message. It has been sent.</div> 
                            : null
                          }
                          {
                            this.state.failureSent? 
                            <div className="response-output-wrong"><i className="far fa-exclamation-circle"></i> Something goes wrong! Please try again later.</div> 
                            : null
                          }                         
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
      </section>
    )
  }
}
export default ContactSection